/**
 * Show element again when it is viually hidden
 * @param {Element} element Element that should be shown
 * @returns {void}
 */
export default (element) => {
  element.removeAttribute('hidden');
  element.removeAttribute('aria-hidden');
};
